<template>
  <Modal :activeModal="activeModal" @closeModal="closeModal">
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
        Baixar prêmio
        <v-spacer></v-spacer>
        <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <v-container fluid class="pb-0">
        <v-col>
          <v-card>
            <v-card-title>
                  Revendedor: {{ revenda }}
            </v-card-title>
            <template v-for="(v, k) in dadosJogos">
            <v-card-text :key="k" class="pb-0">
              <hr v-if="k !== 0">
              <v-row :class="[k === 0 ? '': 'pt-3 pb-3']">
                  <v-col cols="12" class="pa-3 pt-0 pb-1">
                  </v-col>
                  <v-col cols="12" class="pa-3 pt-0 pb-1">
                    N° Jogo: <strong> {{ qtdItens === 1 ? v.nrJogo : format(v.nrJogo, 'gameId') }} </strong>
                  </v-col>
                  <v-col cols="12" class="pa-3 pt-0 pb-1">
                    Valor Jogo: <strong> {{ v.vlJogo | currency }} </strong>
                  </v-col>
                  <v-col cols="12" class="pa-3 pt-0 pb-1">
                    Valor Prêmio: <strong> {{ qtdItens === 1 ? v.vlPremio : format(v.nrJogo, 'value') | currency }} </strong>
                  </v-col>
                </v-row>
            </v-card-text>
              </template>
          </v-card>
        </v-col>

      </v-container>

      <v-card-actions class="modal-cadastro-footer">
        <v-btn :color="variables.colorPrimary" @click="closeModal" class="br-btn br-btn-cancelar">Não</v-btn>
        <v-btn type="submit" :color="variables.colorPrimary" @click.prevent="baixarPremio" class="br-btn" :loading="loading">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
// import { required } from 'vuelidate/lib/validators'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import { each, size } from 'lodash'
import validacao from './validacao'

// eslint-disable-next-line
const namespaceStore = ''

export default {
  name: 'ModalJogos',
  mixins: [validationMixin],
  components: {
    Modal: () => import('@/views/components/modal')
  },
  data: () => ({
    activeModal: false,
    loading: false,
    nameRevenda: '',
    dadosJogos: []
  }),
  
  computed: {
    qtdItens () {
      return size(this.dadosJogos)
    },
    revenda () {
      let dados = this.nameRevenda
      return dados
    },
    ...validacao,
    variables: () => variables
  },
  mounted () {
    Events.$on('ganhadores::modal::baixar', (e) => {
      this.getEntities({ id: e.entityId || e.params[0].resale}).then(result => {
        const dados = result.resultMap[0]
        this.nameRevenda = `${dados.cod} - ${dados.name}`
      })
      if (e.params && e.params.list !== null && e.params.list[0]) {
        each(e.params, v => {
          this.dadosJogos.push({
            id: e.id,
            nrJogo: v,
            vlJogo: 1,
            vlPremio: 1,
            guessWinnerId: e
          })
        })
      } else {
        this.dadosJogos.push({
          id: e.id,
          nrJogo: e.winners.games.gameNumber,
          vlJogo: e.winners.totais.guessValue,
          vlPremio: e.value
        })
      }
      this.activeModal = true
    })
  },
  methods: {
    ...mapActions('resgate', ['editarItem']),
    ...mapActions('entities', ['getEntities']),
    format(v, key) {
      return v[key]
    },
    closeModal () {
      this.activeModal = false
      // this.limparItem()
      // this.$v.item.$reset()
      this.dadosJogos = []
    },

    baixarPremio () {
      const vm = this
      vm.loading = true
      let validate = size(this.dadosJogos)
      if (validate === 0) {
        return errorSnackbar('Dados inválidos')
      }
      let dados = this.dadosJogos[0]

      this.editarItem({...dados})
        .then(() => {
          successSnackbar('Baixa de prêmio(s) realizada com sucesso!')
          Events.$emit('update::view::baixa')
          vm.loading = false
          this.closeModal()
        })
        .catch(e => {
          errorSnackbar(e.error)
        })
        .finally(() => this.loading = false)
    }
  },

  beforeDestroy () {
    Events.$off('ganhadores::modal::baixar')
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/formularios';
  @import '~@/assets/styles/components/modal-cadastro';
</style>